import * as Tokens from '@hedtech/react-design-system/core/es/styles/tokens';
import * as InternalTokens from './internalTokens';
export { default as CtaColors } from '@hedtech/react-design-system/core/es/themes/common/ctaColors';
export default Object.assign(Object.assign({}, Tokens), InternalTokens);
